import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Step from './Step';
import {
  STEP_AVAILABILITY,
  STEP_ROOMS,
  STEP_CHECKOUT,
  STEP_PRODUCTS,
} from '../../../../helpers/steps';
import UrlHelper from '../../../../helpers/url-helper';

const Stepper = props => {
  const {
    arrivalDate, departureDate, couponCode, adults, children,
    askSuiteId, widget, current,
  } = props;
  const { t } = useTranslation();
  const productsAds = useSelector(state => state.products.ads);

  const showExtras = Array.isArray(productsAds) && productsAds.length > 0;

  const step1Active = current === STEP_AVAILABILITY;
  const step1Done   = [STEP_ROOMS, STEP_PRODUCTS, STEP_CHECKOUT].includes(current);
  const step2Active = current === STEP_ROOMS;
  const step2Done   = [STEP_PRODUCTS, STEP_CHECKOUT].includes(current);
  const step3Active = current === STEP_PRODUCTS;
  const step3Done   = current === STEP_CHECKOUT;
  const step4Active = current === STEP_CHECKOUT;
  const paymentNum  = showExtras ? 4 : 3;

  const buildUrl = route =>
    UrlHelper.toInternalRoute(route, arrivalDate, departureDate, couponCode, '', adults, children, null, askSuiteId, widget);

  const homeUrl     = buildUrl('/');
  const roomsUrl    = buildUrl('rooms');
  const productsUrl = buildUrl('products');

  return (
    <div className="stepper">
      <Step step={1} label={t('stepper.checkin')} active={step1Active} done={step1Done} link={step1Done} url={homeUrl} />
      <div className="step-connector" />
      <Step step={2} label={t('titles.rooms')} active={step2Active} done={step2Done} link={step2Done} url={roomsUrl} />
      <div className="step-connector" />
      {showExtras && (
        <>
          <Step step={3} label={t('stepper.extras')} active={step3Active} done={step3Done} link={step3Done} url={productsUrl} />
          <div className="step-connector" />
        </>
      )}
      <Step step={paymentNum} label={t('titles.payment')} active={step4Active} link={false} />
    </div>
  );
};

Stepper.propTypes = {
  arrivalDate:   PropTypes.string,
  departureDate: PropTypes.string,
  couponCode:    PropTypes.string,
  current:       PropTypes.string,
};

export default Stepper;
